import { render } from "./Matches.vue?vue&type=template&id=3e90455c"
import script from "./Matches.vue?vue&type=script&lang=ts"
export * from "./Matches.vue?vue&type=script&lang=ts"
script.render = render

export default script